import "./App.css";
import { Header, ParalaxHeader } from "./components/header";
import { SocialFeed } from "./components/socialFeed/socialFeed";
import { HowItWorks } from "./components/howItWorks/howItWorks";
import { Sponsors } from "./components/sponsors/sponsors";
import { Footer } from "./components/footer/footer";
import { SupportCommunity } from "./components/supportCommunity/supportCommunity";
import { LinksSection } from "./components/linksSection/linksSection";
import PresentersBar from "./components/presentersBar/PresentersBar";

function App() {
  return (
    <div className="App">
      <Header />
      <PresentersBar />
      <HowItWorks />
      <SupportCommunity />
      {/* <SocialFeed /> */}
      <LinksSection />
      <Sponsors />
      <PresentersBar />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
